import ProfilePage from './ProfilePage';

const routes = [
    { path: 'account/profile', component: () => <ProfilePage />, isPublic: false, isSidebar: true },
]

export default routes;
